import React, { useState } from "react";
import {
  fieldsDetail,
  isFormAtom,
} from "../../components/admin/DndTemplate/DndAtom/DndTemplateAtom";
import { useAtom } from "jotai";
import { DroppableContainer } from "../../components/admin/DndTemplate/helper/DndHelper";
import CuModal from "../../common_component/component/CuModal";
import FormComponent from "./FormComponent";
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import Confirmation from "./Confirmation";
import RenderFields from "./RenderFields";
const DropBox = ({ selectedValue }) => {
  const [items, setItems] = useState([]);

  const [isForm, setIsForm] = useAtom(isFormAtom);
  const [fields, setFields] = useAtom(fieldsDetail);
  const [clinic] = useAtom(clinicAtom);

  const fieldClickHandler = (field) => {
    setIsForm({ isForm: true, id: field.id, isEdit: true });
  };

  const deleteClickHandler = (field) => {
    setIsForm({ isForm: true, data: field, isDelete: true });
  };

  const onClose = () => {
    setIsForm({ isForm: false, id: "", isDelete: false });
  };

  const handleDelete = () => {
    setFields((prevFields) =>
      prevFields.filter((field) => field.id !== isForm.data.id)
    );
    onClose(); // Close the modal after deletion
  };

  console.log(fields);

  return (
    <div>
      <DroppableContainer droppableId="dest">
        <div className="w-full min-h-[450.89px]">
          <div className="w-full h-full">
            <form>
              {fields?.map((field) => (
                <div key={field.id} className="flex items-center gap-4 mt-2">
                  {/* <div className="border w-[320px] h-[48px] flex px-4 items-center rounded"> */}
                  {/* Render the specific field content */}
                  {<RenderFields field={field} />}
                  {/* </div> */}

                  {/* Edit and Delete icons */}
                  <MdEdit
                    size={20}
                    className="cursor-pointer"
                    onClick={() => fieldClickHandler(field)}
                  />
                  <MdDelete
                    size={20}
                    onClick={() => deleteClickHandler(field)}
                    className="cursor-pointer"
                  />
                </div>
              ))}
            </form>
          </div>
        </div>
      </DroppableContainer>

      {isForm.isDelete && isForm.isForm && (
        <CuModal
          closeModal={() =>
            setIsForm({ isForm: false, id: "", isDelete: false })
          }
        >
          <Confirmation
            heading={`Delete ${isForm?.data?.display_name}`}
            onCancel={onClose}
            onClick={handleDelete}
          />
        </CuModal>
      )}

      {(isForm.isEdit || isForm.isOpen || isForm?.isPredifined) && (
        <CuModal
          closeModal={() =>
            setIsForm({
              isForm: false,
              id: "",
              data: "",
              isEdit: false,
              isOpen: false,
              isPredifined: false,
            })
          }
        >
          <FormComponent selectedValue={selectedValue} />
        </CuModal>
      )}
    </div>
  );
};

export default DropBox;
